export default "__VITE_ASSET__Dd4OvEM2__"